import TabCell from "../TabCell";
import {GoingUtils,AssertUtils} from "goingutils";
import {
    _dataFromMap,
    _getSplitBar,
    _initSplitBarEvent,
} from "../comJs";

import GridPanelUtils from "./gridPanelUtils";
import GoTabUrl from "../goTabsUrl";

class OutUnitUserTabs extends TabCell {

    constructor(vueObj, goTabs) {
        super();
        this.tabId = GoingUtils.getUUid(10);
        this.tabIdName = "outPerson";
        this.tabLabel = "编外人员";
        this.dataFrom = _dataFromMap["user"];
        this.active = false;
        this.hasSaveGroup = false;
        this.goTabs = goTabs;
        this.excludeIds=this.goTabs.excludeIds;
    }

    getLeftCellContent(panelHeight) {
        //缓存其panel的高度
        this.panelHeight = panelHeight;
        this.leftTopCellHeight = parseFloat(panelHeight + "") * 0.45 - 40;
        this.leftBottomCellHeight = parseFloat(panelHeight + "") * 0.55 - 20;
        let leftBottomGridHeight = this.leftBottomCellHeight + "px";

        return `${GridPanelUtils.initLeftCellContent(this, this.leftTopCellHeight + "px", this.leftTopCellHeight - 5 + "px", "请输入编外单位名称", this.tabId, false, 160, 180)}
            ${_getSplitBar()} 
            <div class="wait-sel-user">
                  <div id="${
            this.tabId
            }_userGrid" style="height: ${leftBottomGridHeight};"></div>
             </div>
           `;
    }

    /**
     * 获取子表的查询url
     * @param rowId
     */
    getSubGridQueryUrl(rowId) {
        return GoTabUrl.queryOutUserByOutUnitId(rowId);
    }

    getRightCellContent(panelHeight) {
        return this._getRightCellContent(panelHeight, this, 200);
    }


    //将数据添加到已选表格中
    addLeftTopRecordToAlreadyGrid(rowId, orgGrid) {
        GridPanelUtils._addLeftTopRecordToAlreadyGrid(this, rowId, orgGrid, this.dataFrom, "name");
    }

    //初始化外单位表格数据
    initOutUnitGrid() {
        let cellObj = this;
        cellObj.itemConfig["selLeftTopRecord"] = cellObj.itemConfig["selOutUnit"];
        cellObj.clickType = "flushSubGrid";
        //待选数据
        cellObj.leftTopGrid = GridPanelUtils.initOutUnitGrid(cellObj, true, false);
    }


    /**
     * 根据外单位id 获取该单位id下的人员信息
     * @param outUnitId
     */
    searchOutUnitUser(outUnitId) {
        if (AssertUtils.isNotEmpty(outUnitId)) {
            this.waitSelGrid.flushGridByUrl({
                url: GoTabUrl.queryOutUserByOutUnitId(outUnitId),
                params: {}
            });
        }
    }

    //初始化tabcell的容器控件
    initTabCellCtl() {
        let cellObj = this;
        //初始化岗位表格信息
        this.initOutUnitGrid();
        //待选择数据的表格
        this.initAlreadyGrid();
        let backFun=()=>{
            this.excludeIds&&this.excludeIds.forEach((recordId)=>{
                if(AssertUtils.isNotEmpty(recordId)){
                    this.waitSelGrid.deleteRow(recordId);
                }
            });
        };
        //待选数据
        this.initWaitGrid(this.tabId + "_userGrid",backFun);
        //初始化账套缺省默认值
        this.initAccountDefVal(this.getLoadFormStorageFlag(), cellObj);
        //设置缺少值
        this.initDefEvent({
            topHeight: 70,
            searchFun: function () {
                cellObj.loadOutUnitGrid();
            },
            //查询右边已选的数据表格
            searchAlSelFun: () => {
                this.searchAlSelGrid();
            }
        });
        this.initCtlEvent();
    }


    //初始化控件事件
    initCtlEvent() {
        var tabCellObj = this;
        //初始化分隔栏的事件
        _initSplitBarEvent(tabCellObj);
        this.initIconBtnEvent();
        this.searchAlReadyRecord(this);
    }


    /**
     * 加载单位表格数据
     * @param nodeId
     * @param cellObj
     */
    loadOutUnitGrid(nodeId) {
        let cellObj = this;
        cellObj.initFirstData = true;
        //只有存在账套id才进行查询
        if (AssertUtils.isNotEmpty(nodeId)) {
            //重新加载岗位表格信息
            this.leftTopGrid.flushGridByUrl({
                url: GoTabUrl.getOutUnitByAccountId(nodeId),
                params: GridPanelUtils.getLoadGridParams(cellObj, nodeId, "outUnitUser")
            });
            //清空岗位下用户表格信息
            if (cellObj.waitSelGrid != null) {
                cellObj.waitSelGrid.clearAll();
            }
        }
    }

    allCheckBoxClick() {
    }

    /**
     * 选择账套的事件
     * @param nodeId
     * @param cellObj
     */
    changeAccountEvent(nodeId, cellObj) {
        if (cellObj.waitSelGrid != null) {
            cellObj.waitSelGrid.clearAll();
        }
        cellObj.initFirstData = true;
        cellObj.loadOutUnitGrid(nodeId);
    }

    destructionTab() {
        //销毁公共组件
        this._desCommonCtl();

        if (this.leftTopGrid != null && AssertUtils.isFunction(this.leftTopGrid.destructor)) {
            this.leftTopGrid.destructor();
            this.leftTopGrid = null;
        }

        if (this.waitSelGrid != null && AssertUtils.isFunction(this.waitSelGrid.destructor)) {
            this.waitSelGrid.destructor();
            this.waitSelGrid = null;
        }
    }

    removeSelectedRecord() {
    }
}

function initOutPersonTab(goTabs, vueObj) {
    let groupTab = new OutUnitUserTabs(vueObj, goTabs);
    goTabs.addTabToFactory("outPerson", groupTab);
}

export default initOutPersonTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/outUnitUserTabs.js